module.exports = __webpack_public_path__ + "img/pns_float_ico_half.6ed0f5ca.png";